import { useNavigation } from "@react-navigation/native";
import {
  BackButton,
  Box,
  MainText,
  PressableOpacity,
} from "app/components/common";
import theme from "app/Theme/Theme";
import React from "react";
import normalize from "app/utils/normalize";
import ArrowRightSlider from "app/components/Icons/ArrowSlider/ArrowRightSlider";
import { IBreadCrumbPath } from "./types";

interface IProps extends IBreadCrumbPath {}

export const Breadcrumb = ({ breadcrumbsPath = [] }: IProps) => {
  const breadcrumbsPathLength = breadcrumbsPath.length;

  const navigation = useNavigation();

  const handleBackArrow = () => {
    if (breadcrumbsPathLength > 1) {
      navigation.navigate(breadcrumbsPath[breadcrumbsPathLength - 2].routeName);
    }
  };

  const handleNavigation = (path, isLastItem) => () => {
    if (!isLastItem) {
      navigation.navigate(path?.routeName);
    }
  };

  return (
    <Box alignItems="center" flexDirection="row">
      {breadcrumbsPath.length > 1 && (
        <BackButton
          size={normalize(30)}
          onPress={handleBackArrow}
          isArrowSlider
        />
      )}
      {breadcrumbsPath.map((path, i) => {
        const isLastItem = i === breadcrumbsPath.length - 1;
        return (
          <Box flexDirection="row" key={i}>
            <PressableOpacity
              style={{
                cursor: !isLastItem ? "pointer" : 0,
              }}
              onPress={handleNavigation(path, isLastItem)}
            >
              <MainText
                variant={"l4-medium"}
                style={{
                  fontSize: 16,
                  color: isLastItem
                    ? theme.colors["neutral.900"]
                    : theme.colors["neutral.400"],
                }}
              >
                {path.label}
              </MainText>
            </PressableOpacity>
            {!isLastItem && (
              <ArrowRightSlider
                height={normalize(20)}
                width={normalize(20)}
                color={theme.colors["neutral.400"]}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
};
